import xIcon from "@tabler/icons/outline/x.svg";
import React from "react";
import { defineMessages, FormattedMessage, useIntl } from "react-intl";

import { HStack, IconButton, Text } from "../ui";

const messages = defineMessages({
  remove: {
    id: "combobox.recent-searches.remove",
    defaultMessage: "Remove {term} from recent searches",
  },
});

interface RecentSearchesHeaderProps {
  onClearAll(): void;
}

export function RecentSearchesHeader({
  onClearAll,
}: RecentSearchesHeaderProps) {
  return (
    <HStack
      alignItems="center"
      justifyContent="between"
      className="bg-white px-4 py-2 dark:bg-gray-900"
      data-testid="recent-searches"
    >
      <Text theme="muted" weight="semibold" size="sm">
        <FormattedMessage
          id="combobox.recent-searches.title"
          defaultMessage="Recent searches"
        />
      </Text>

      <button
        type="button"
        onClick={onClearAll}
        data-testid="clear-recent-searches"
      >
        <Text theme="primary" size="sm" className="hover:underline">
          <FormattedMessage
            id="combobox.recent-searches.clear-all"
            defaultMessage="Clear all"
          />
        </Text>
      </button>
    </HStack>
  );
}

interface RecentSearchRowProps {
  term: string;
  onRemove(): void;
}

export function RecentSearchRow({ term, onRemove }: RecentSearchRowProps) {
  const intl = useIntl();

  return (
    <HStack
      alignItems="center"
      justifyContent="between"
      className="min-w-0 flex-1"
    >
      <Text weight="bold" size="sm" align="left" truncate>
        {term}
      </Text>

      <IconButton
        src={xIcon}
        iconClassName="size-4"
        aria-label={intl.formatMessage(messages.remove, { term })}
        data-testid="clear-recent-search"
        className="shrink-0"
        // The row is a combobox option that commits on pointer down, so the
        // remove button has to opt out of the gesture before it starts.
        onPointerDown={(event) => event.stopPropagation()}
        onMouseDown={(event) => event.stopPropagation()}
        onClick={(event) => {
          event.stopPropagation();
          onRemove();
        }}
      />
    </HStack>
  );
}
